import type { ReactNode } from "react";
import { T } from "./tokens";

interface ActionChipProps {
  icon?: ReactNode;
  label: string;
  sub?: string;
  muted?: boolean;
  onClick?: () => void;
}

export function ActionChip({ icon, label, sub, muted, onClick }: ActionChipProps) {
  return (
    <button
      onClick={onClick}
      className="nig-press nig-tap"
      style={{
        flex: 1,
        padding: "11px 10px",
        borderRadius: T.r2,
        background: muted ? "transparent" : `${T.gold}10`,
        border: `1px solid ${muted ? T.hairline : T.gold + "40"}`,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: 2,
        color: muted ? T.mist : T.gold,
        fontFamily: T.sans,
        cursor: "pointer",
      }}
    >
      <div style={{ display: "flex", alignItems: "center", gap: 6 }}>
        {icon}
        <span style={{ fontSize: 12.5, fontWeight: 600 }}>{label}</span>
      </div>
      {sub && <span style={{ fontSize: 10, opacity: 0.75 }}>{sub}</span>}
    </button>
  );
}
